import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304007Status: 'idle',
    startProcess304007Error: undefined as any,
    loadUserParamsProcess304007Status: 'idle',
    loadUserParamsProcess304007Error: undefined as any,

    process304007List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304007 = createAsyncThunk('process304007Slice/startProcess304007', async ({ process304007 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304007/`,
        prepareData(process304007),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304007Status } = getState().process304007Slice
        return startProcess304007Status !== 'pending'
    }
})

export const loadUserParamsProcess304007 = createAsyncThunk('process304007Slice/loadUserParamsProcess304007', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304007/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304007Status } = getState().process304007Slice
        return loadUserParamsProcess304007Status !== 'pending'
    }
})

const Process304007Slice = createSlice({
    name: 'process304007Slice',
    initialState,
    reducers: {
        resetstartProcess304007: (state) => {
            state.job = undefined
            state.startProcess304007Error = undefined
        },
        resetstartProcess304007Error: (state) => {
            state.startProcess304007Error = undefined
        },
        resetloadUserParamsProcess304007: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304007Error = undefined
        },
        resetloadUserParamsProcess304007Error: (state) => {
            state.loadUserParamsProcess304007Error = undefined
        },
        removeFromProcess304007ListById: (state, action) => {
            state.process304007List = state.process304007List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304007ListByIds: (state, action) => {
            state.process304007List = state.process304007List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304007List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304007Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304007List = []
            state.startProcess304007Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304007.pending, (state) => {
            state.startProcess304007Status = 'pending'
            state.startProcess304007Error = undefined
        })
        builder.addCase(startProcess304007.fulfilled, (state, action) => {
            state.startProcess304007Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304007.rejected, (state, action) => {
            state.startProcess304007Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304007Error = action.error.message
            } else {
                state.startProcess304007Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304007.pending, (state) => {
            state.loadUserParamsProcess304007Status = 'pending'
            state.loadUserParamsProcess304007Error = undefined
        })
        builder.addCase(loadUserParamsProcess304007.fulfilled, (state, action) => {
            state.loadUserParamsProcess304007Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304007.rejected, (state, action) => {
            state.loadUserParamsProcess304007Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304007Error = action.error.message
            } else {
                state.loadUserParamsProcess304007Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304007,
    resetstartProcess304007Error,
    resetloadUserParamsProcess304007,
    resetloadUserParamsProcess304007Error,
    removeFromProcess304007ListById,
    removeFromProcess304007ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304007Slice.actions
export default Process304007Slice.reducer
